<template>
  <div id="lom-information-page">
    <!-- Loading Overlay -->
    <v-overlay :value="ProgressLoadingFlag">
      <v-progress-circular indeterminate size="60" color="primary"></v-progress-circular>
    </v-overlay>

    <!-- Premium Page Header -->
    <v-card elevation="20" class="header-card mb-6 overflow-hidden">
      <div class="header-gradient">
        <div class="header-backdrop-effect"></div>
        <v-container fluid class="header-container">
          <v-row align="center" justify="space-between" class="ma-0">
            <!-- Title Section - Left -->
            <v-col cols="12" md="8" class="d-flex align-center gap-3">
              <div class="header-icon-box">
                <v-icon size="32" class="icon-white">mdi-information-outline</v-icon>
              </div>
              <div class="header-title-bar">
                <h1 class="header-title">Local Organization Information</h1>
                <p class="header-subtitle">
                  {{ LomName }} - {{ LomCode }}
                </p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card>

    <v-card-text class="page-content">
      <!-- Information Cards Grid -->
      <v-container fluid class="pa-0">
        <v-row class="mb-6">
          <!-- Specimen Signature Card -->
          <v-col cols="12" lg="4" md="6" sm="12" class="mb-4">
            <v-card class="info-card ss-card-wrapper" elevation="8">
              <div class="card-header card-header--signatures">
                <div class="card-header-icon">
                  <v-icon>mdi-pen</v-icon>
                </div>
                <div class="card-header-content">
                  <h3 class="card-title">Specimen Signature Card</h3>
                  <p class="card-subtitle">Authorized signatories</p>
                </div>
              </div>
              <v-card-text class="card-body pt-4">
                <ss-card></ss-card>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- LO Affiliation Status Card -->
          <v-col cols="12" lg="4" md="6" sm="12" class="mb-4">
            <v-card class="info-card affiliation-card-wrapper" elevation="8">
              <div class="card-header card-header--affiliation">
                <div class="card-header-icon">
                  <v-icon>mdi-file-document</v-icon>
                </div>
                <div class="card-header-content">
                  <h3 class="card-title">Affiliation Status</h3>
                  <p class="card-subtitle">Document verification</p>
                </div>
              </div>
              <v-card-text class="card-body pt-4">
                <affiliation-document-list></affiliation-document-list>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- LO Votes Card -->
          <v-col cols="12" lg="4" md="6" sm="12" class="mb-4">
            <v-card class="info-card voting-card-wrapper" elevation="8">
              <div class="card-header card-header--voting">
                <div class="card-header-icon">
                  <v-icon>mdi-hand-right</v-icon>
                </div>
                <div class="card-header-content">
                  <h3 class="card-title">Voting Rights</h3>
                  <p class="card-subtitle">Vote count</p>
                </div>
              </div>
              <v-card-text class="card-body pt-4">
                <voting-count></voting-count>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Location Details Card -->
          <v-col cols="12" lg="4" md="6" sm="12" class="mb-4">
            <v-card class="info-card location-card-wrapper" elevation="8">
              <div class="card-header card-header--location">
                <div class="card-header-icon">
                  <v-icon>mdi-map-marker</v-icon>
                </div>
                <div class="card-header-content">
                  <h3 class="card-title">Location Details</h3>
                  <p class="card-subtitle">Address information</p>
                </div>
              </div>
              <v-card-text class="card-body pt-4">
                <location-information-list></location-information-list>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- First ZVP Visit Card -->
          <v-col cols="12" lg="4" md="6" sm="12" class="mb-4">
            <v-card class="info-card ldmt-card-wrapper" elevation="8">
              <div class="card-header card-header--ldmt">
                <div class="card-header-icon">
                  <v-icon>mdi-calendar-check</v-icon>
                </div>
                <div class="card-header-content">
                  <h3 class="card-title">ZVP First half visit</h3>
                  <p class="card-subtitle">First Half Status</p>
                </div>
              </div>
              <v-card-text class="card-body pt-4">
                <ldmt-status></ldmt-status>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Second ZVP Visit Card -->
          <v-col cols="12" lg="4" md="6" sm="12" class="mb-4">
            <v-card class="info-card lav-card-wrapper" elevation="8">
              <div class="card-header card-header--lav">
                <div class="card-header-icon">
                  <v-icon>mdi-calendar-star</v-icon>
                </div>
                <div class="card-header-content">
                  <h3 class="card-title">ZVP Second half visit</h3>
                  <p class="card-subtitle">Second Half Status</p>
                </div>
              </div>
              <v-card-text class="card-body pt-4">
                <lav-status></lav-status>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import LocationInformationList from "@/view/pages/erp/lom/lom-information/LocationInformationList.vue";
import BankInformationList from "@/view/pages/erp/lom/lom-information/BankInformationList.vue";
import AffiliationDocumentList from "@/view/pages/erp/lom/affilication-document/AffiliationDocumentList.vue";
import SsCard from "@/view/pages/erp/lom/lom-information/SsCard.vue";
import VotingCount from "@/view/pages/erp/lom/lom-information/VotingCount.vue";
import LdmtStatus from "@/view/pages/erp/lom/lom-information/LdmtStatus.vue";
import LavStatus from "@/view/pages/erp/lom/lom-information/LavStatus.vue";

export default {
  mixins: [common],
  components: {
    BankInformationList,
    LocationInformationList,
    AffiliationDocumentList,
    SsCard,
    VotingCount,
    LdmtStatus,
    LavStatus,
  },
  data() {
    return {
      ProgressLoadingFlag: false,
      VotingRightsStatus: "",
      DocumentPath: "",
      uploadDocumentPrompt: false,
      EditRecordPrompt: false,
      presidentDatePrompt: false,
      lomInformationStatus: false,

      EligibleCount: 0,
      selectedData: {},
      VotingData: {},

      LdmtCardFlag: true,
      LavCardFlag: false,

      LomName: "",
      LomCode: "",

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.ProgressLoadingFlag = false;
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        var LomName = this.$session.get("LomName");
        LomName = LomName == (null || undefined) ? "" : LomName;
        console.log({ LomName });
        this.LomName = LomName;

        var server_url = companyConfig.apiURL;
        console.log("server_url = " + server_url);
        var SampleFilePath = server_url + "assets/sample/voting_rights.pdf";
        console.log("SampleFilePath = " + SampleFilePath);
        this.SampleFilePath = SampleFilePath;
      }
    },
  },
  methods: {
    backPage() {
      this.$router.go(-1);
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.ProgressLoadingFlag = true;
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "voting_rights",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.pageData();
    },
    pageData() {
      console.log("pageData called");
      // this.getTableRecords();
    },
    clickPresidentDate() {
      console.log("clickDate called");
      var tr = this.Records;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.presidentDatePrompt = true;
        this.rowData = tr;
      } else {
        var message = "Selected Date failed";
        this.toast("error", message);
      }
    },
    approvedStatus() {
      console.log("clickDate called");
      var tr = this.Records;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.lomInformationStatus = true;
        this.selectedData = tr;
      } else {
        var message = "Votingdescription failed";
        this.toast("error", message);
      }
    },
    hideUploadRecordPrompt() {
      console.log("hideUploadRecordPrompt called");
      this.uploadDocumentPrompt = false;
      // this.getTableRecords();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.EditRecordPrompt = false;
    },
    editData() {
      console.log("editData called");
      var tr = this.VotingData;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        this.EditRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Votingdescription failed";
        this.toast("error", message);
      }
    },
  },
  mounted() { },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
// Color Palette (JCI Approved Colors)
$navy: #3a67b1;
$aqua: #0097d7;
$gold: #edbe38;
$seaform: #56bda3;
$text-90-black: #414042;
$text-off-black: #0a0f29;
$text-white: #ffffff;
$signature-color: $navy;
$affiliation-color: $seaform;
$voting-color: $navy;
$location-color: $aqua;
$ldmt-color: $navy;
$lav-color: $seaform;

$primary-color: $navy;
$secondary-color: $aqua;
$success-color: $seaform;
$warning-color: $gold;
$danger-color: #e74c3c;
$info-color: $aqua;
$light-bg: #f8fafc;
$bg-light: #f1f5f9;
$text-primary: $text-off-black;
$text-secondary: $text-90-black;
$border-color: #e2e8f0;

// Animations
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-12px);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

#lom-information-page {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 30px 15px;

  // ============================================
  // HEADER CARD
  // ============================================
  .header-card {
    background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
    border-radius: 20px;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.5),
      0 0 30px rgba(0, 151, 215, 0.3);

    &::before {
      content: "";
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle,
          rgba(255, 255, 255, 0.1) 0%,
          transparent 70%);
      animation: float 8s ease-in-out infinite;
    }
  }

  .header-backdrop-effect {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    opacity: 0.5;
  }

  .header-container {
    padding: 20px 0 !important;
  }

  .header-icon-box {
    background: linear-gradient(135deg,
        rgba(255, 255, 255, 0.25) 0%,
        rgba(255, 255, 255, 0.15) 100%);
    backdrop-filter: blur(15px);
    border-radius: 18px;
    padding: 14px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.4);
    animation: float 4s ease-in-out infinite;
    border: 2px solid rgba(255, 255, 255, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;

    .icon-white {
      color: $text-white !important;
    }
  }

  .header-title-bar {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .header-title {
    font-size: 36px;
    font-weight: 900;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 151, 215, 0.3);
    animation: slideInLeft 0.8s ease-out;
    letter-spacing: 0.8px;
    color: $text-white;
    margin: 0;
  }

  .header-subtitle {
    font-size: 17px;
    opacity: 0.98;
    animation: slideInLeft 1s ease-out 0.1s backwards;
    letter-spacing: 0.4px;
    color: $text-white;
    font-weight: 500;
    margin: 0;
  }

  .gap-3 {
    gap: 1rem !important;
  }

  .action-btn {
    background: rgba(255, 255, 255, 0.15) !important;
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
    backdrop-filter: blur(10px);
    color: white !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      background: rgba(255, 255, 255, 0.25) !important;
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    }
  }

  // ============================================
  // PAGE CONTENT
  // ============================================
  .page-content {
    padding: 0;
  }

  // ============================================
  // INFO CARDS
  // ============================================
  .info-card {
    border-radius: 18px !important;
    border: 2px solid rgba(58, 103, 177, 0.15) !important;
    box-shadow: 0 12px 40px rgba(58, 103, 177, 0.15),
      0 0 30px rgba(0, 151, 215, 0.08);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    animation: slideInUp 0.6s ease-out;
    background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(circle at 20% 50%,
          rgba(58, 103, 177, 0.05) 0%,
          transparent 50%);
      pointer-events: none;
    }

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 20px 60px rgba(58, 103, 177, 0.2),
        0 0 40px rgba(0, 151, 215, 0.15);
      border-color: rgba(0, 151, 215, 0.3) !important;
    }
  }

  .card-header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px;
    border-radius: 16px 16px 0 0;
    background: linear-gradient(135deg, $navy 0%, $aqua 100%);
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle,
          rgba(255, 255, 255, 0.1) 0%,
          transparent 70%);
      animation: float 6s ease-in-out infinite;
    }
  }

  .card-header--signatures {
    background: linear-gradient(135deg, $navy 0%, lighten($navy, 10%) 100%);
  }

  .card-header--affiliation {
    background: linear-gradient(135deg, $seaform 0%, darken($seaform, 10%) 100%);
  }

  .card-header--voting {
    background: linear-gradient(135deg, $gold 0%, darken($gold, 15%) 100%);
  }

  .card-header--location {
    background: linear-gradient(135deg, $aqua 0%, lighten($aqua, 10%) 100%);
  }

  .card-header--ldmt {
    background: linear-gradient(135deg, $navy 0%, $aqua 100%);
  }

  .card-header--lav {
    background: linear-gradient(135deg, $seaform 0%, $aqua 100%);
  }

  .card-header-icon {
    background: rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid rgba(255, 255, 255, 0.3);
    flex-shrink: 0;
    position: relative;
    z-index: 1;

    .v-icon {
      color: $text-white !important;
      font-size: 24px;
    }
  }

  .card-header-content {
    flex: 1;
    position: relative;
    z-index: 1;
  }

  .card-title {
    font-size: 18px;
    font-weight: 700;
    color: $text-white;
    margin: 0;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  .card-subtitle {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.9);
    margin: 4px 0 0 0;
    font-weight: 500;
    opacity: 0.95;
  }

  .card-body {
    padding: 20px !important;
    position: relative;
    z-index: 1;
  }

  // ============================================
  // RESPONSIVE DESIGN
  // ============================================
  @media (max-width: 960px) {
    .header-card {
      margin-bottom: 20px !important;
    }

    .header-title {
      font-size: 28px !important;
    }

    .header-subtitle {
      font-size: 14px !important;
    }
  }

  @media (max-width: 600px) {
    padding: 15px;

    .header-card {
      margin-bottom: 15px !important;
    }

    .header-title {
      font-size: 24px !important;
    }

    .header-subtitle {
      font-size: 12px !important;
    }

    .info-card {
      margin-bottom: 12px !important;
    }

    .card-title {
      font-size: 16px !important;
    }

    .card-subtitle {
      font-size: 12px !important;
    }
  }
}
</style>